import React, { useState, useContext } from "react";
import { Modal, Select, Input, message } from "antd";
import axios from "axios";
import { API_DOMAIN } from "../constants";
import { AuthContext } from "../contexts/AuthContext";

const UNPARK_STATUSES = [
  { value: "waiting_for_price",             label: "Waiting For Price" },
  { value: "waiting_customer_confirmation", label: "Waiting Confirmation" },
  { value: "confirmed_waiting_payment",     label: "Confirmed · Awaiting Payment" },
  { value: "paid",                          label: "Paid" },
  { value: "completed",                     label: "Completed" },
  { value: "cancelled",                     label: "Cancelled" },
];

export function UnparkModal({ open, queryPk, onClose, onSuccess }) {
  const { authState } = useContext(AuthContext);
  const [toStatus, setToStatus] = useState(null);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    setToStatus(null);
    setReason("");
    onClose();
  };

  const handleOk = async () => {
    if (!toStatus) { message.warning("Select a status to move the task to"); return; }
    if (!reason.trim()) { message.warning("Reason is required"); return; }
    setSaving(true);
    try {
      const res = await axios.post(
        `${API_DOMAIN}/queries/${queryPk}/unpark`,
        { userId: authState?.id, to_status: toStatus, reason: reason.trim() },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      if (!res.data?.success) throw new Error(res.data?.message);
      message.success("Task unparked");
      onSuccess?.();
      handleClose();
    } catch (e) {
      message.error(e?.response?.data?.message || e.message || "Unpark failed");
    } finally { setSaving(false); }
  };

  return (
    <Modal
      open={open}
      title="Unpark Task"
      onCancel={handleClose}
      onOk={handleOk}
      confirmLoading={saving}
      okText="Unpark"
      destroyOnClose
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 16 }}>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: "#595959" }}>Move to</div>
          <Select
            placeholder="Select stage..."
            style={{ width: "100%" }}
            value={toStatus}
            onChange={setToStatus}
            options={UNPARK_STATUSES}
          />
        </div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: "#595959" }}>
            Reason <span style={{ color: "#ff4d4f" }}>*</span>
          </div>
          <Input.TextArea
            rows={3}
            placeholder="e.g. Customer returned to pay balance"
            value={reason}
            onChange={e => setReason(e.target.value)}
            autoFocus
          />
        </div>
      </div>
    </Modal>
  );
}
